module.exports = __webpack_public_path__ + "static/media/carta_96.89db4354.jpg";